import React from "react";
import { makeStyles, Theme, createStyles, Chip } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: theme.spacing(1),
      margin: "0px 10px",
      marginBottom: "2px",
      "&:hover": {
        opacity: 0.9
      }
    },
    chip: {
      cursor: "grab"
    }
  })
);

export interface TrayItemWidgetProps {
  model: any;
  color?: string;
  name: string;
}

export const TrayItemWidget = (props: TrayItemWidgetProps) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Chip
        className={classes.chip}
        draggable={true}
        style={{
          width: 160,
          backgroundColor: props.color,
          backgroundImage:
            "linear-gradient(rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.02))"
        }}
        onDragStart={(event: any) => {
          event.dataTransfer.setData(
            "storm-diagram-node",
            JSON.stringify(props.model)
          );
        }}
        label={props.name}
      />
    </div>
  );
};
